import React from 'react';
import classNames from 'classnames';
import { useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { BaseButton, Icon } from '@alycecom/ui';

import { IAlyceCustomTheme } from '../../styles/alyceTheme';

const useStyles = makeStyles<IAlyceCustomTheme>(({ palette, spacing, breakpoints, zIndex }) => ({
  text: {
    fontWeight: 'bold',
    marginLeft: spacing(1),
    color: palette.customStyling.highlightColor,
    [breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  mobile: {
    borderRadius: 0,
    border: 'none',
    borderRight: `2px solid ${palette.grey.dark}`,
  },
  button: {
    zIndex: zIndex.appBar,
    [breakpoints.down('sm')]: {
      borderRadius: 0,
      border: 'none',
      borderRight: `2px solid ${palette.grey.dark}`,
      height: 56,
      width: 56,
    },
    [breakpoints.up('sm')]: {
      height: 48,
      width: 100,
    },
  },
  icon: {
    color: palette.customStyling.highlightColor,
  },
}));

export interface IBackButtonProps {
  text?: string;
  onSubmit: () => void;
}

const BackButton = ({ text = 'Back', onSubmit }: IBackButtonProps): JSX.Element => {
  const { palette: colors } = useTheme();
  const classes = useStyles();

  return (
    <BaseButton
      overrideClass={classes.button}
      variant="outlined"
      onClick={onSubmit}
      color={colors.link.main}
      bgColor={colors.common.white}
      borderColor={colors.grey.regular}
      data-testid="Header.BackButton"
    >
      <Icon icon="arrow-left" className={classes.icon} />
      <span className={classNames(classes.text, 'backButtonText-ie')}>{text}</span>
    </BaseButton>
  );
};

export default BackButton;
